import { createContext, useContext, useState } from 'react'
import { THEMES } from '../lib/themes'
import { STORAGE_KEYS } from '../lib/storage'

const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [themeKey, setThemeKey] = useState(
    () => localStorage.getItem(STORAGE_KEYS.THEME) || 'florece'
  )
  const theme = THEMES[themeKey] || THEMES.florece

  function setTheme(key) {
    localStorage.setItem(STORAGE_KEYS.THEME, key)
    setThemeKey(key)
  }

  return (
    <ThemeContext.Provider value={{ theme, themeKey, setTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  return useContext(ThemeContext)
}
